var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head"},[_c('div',{staticClass:"headBox flex align-center justify-between"},[_c('div',{staticClass:"headLeft"},[_c('img',{attrs:{"src":_vm.logo === 2 ? _vm.logo2 : _vm.logo1,"alt":""}})]),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"headRight"},[_c('a',{staticClass:"headRightTel",attrs:{"href":"http://zjzk.emof.cn/"}},[_vm._v(" 返回首页 ")])])
}]

export { render, staticRenderFns }